import React from "react";
import Loadergif from "../../assets/logo.png";

export default function Loader() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "transparent",
        zIndex: 9999,
      }}
    >
      <img src={Loadergif} alt="loading" style={{ width: "200px" }} />
    </div>
  );
}
